import * as React from 'react';
import { MatterRelationship, MatterParty } from './PartiesInfo';
import { RvOrganizationTable } from '../../components/Party/OrganizationTable';
import { RvContactTable } from '../../components/Party/ContactTable';
import { MatterTerminology } from '../../MatterTerminology';
// import { RvLabel, LabelStyle } from '../../components/Label/Label';
import { PartyPlainField } from '../../components/Party/PartyCommon';
import { PartyInfoPanel } from '../../components/Party/PartyInfoPanel';
import glamorous from 'glamorous';
// import { mainTheme } from '../../Theme';

const ReferenceWrapper = glamorous.div({
    padding: '0 1em',
});

// Gap between multiple contact/organisation cards stacked under one relationship (e.g. several
// debtors) — same 10px convention RelationshipWrapper already uses between relationship groups
// in Parties.tsx. PartyInfoPanel itself carries no gap of its own (see its own comment).
const PartyCardWrapper = glamorous.div({
    marginBottom: '10px',
});

// tslint:disable-next-line:no-any
const DataContainer = glamorous.div<{ theme?: any  }>((props) => ({
    width: '100%',
}));

interface PartyInfoCardProps {
    key: number;
    showDescription: boolean;
    relationship: MatterRelationship;
}

export class RvPartyInfoTable extends React.Component<PartyInfoCardProps, {}>  {
    public render() {
        var relationship = this.props.relationship;
        var parties = relationship.parties;
        var organisations = relationship.organisations;
        var individuals = relationship.individuals;
        var infoPanelItems = new Array<{}>();
        let partyDescription = '';
        if (this.props.showDescription) {
            partyDescription = relationship.longDescription ?
                relationship.longDescription : relationship.description;
            if (relationship.reference) {
                infoPanelItems.push(
                    <ReferenceWrapper>
                        <PartyPlainField label={MatterTerminology.Reference} value={relationship.reference} />
                    </ReferenceWrapper>
                );
            }
        }
        
        parties.map((party: MatterParty, idx: number) => {
            if (party.partyEnumType === 'ORGANISATION') {
                var organisation = organisations.find(o => o.partyId === party.partyId
                    && o.matterRoleId === party.matterRoleId);
                if (organisation) {
                    infoPanelItems.push(
                        <PartyCardWrapper key={idx}>
                            <RvOrganizationTable
                                data={organisation}
                                phoneNumbers={party.phoneNumbers}
                                emailAddresses={party.emailAddresses}
                                addresses={party.addresses}
                                relatedParties={party.relatedParties}
                                relatedIndividuals={party.relatedIndividuals}
                                relatedOrganisations={party.relatedOrganisations}
                                parentTitle={partyDescription}
                            />
                        </PartyCardWrapper>
                    );
                }
            } else {
                var individual = individuals.find(o => o.partyId === party.partyId
                    && o.matterRoleId === party.matterRoleId);
                if (individual) {
                    infoPanelItems.push(
                        <PartyCardWrapper key={idx}>
                            <RvContactTable
                                data={individual}
                                phoneNumbers={party.phoneNumbers}
                                emailAddresses={party.emailAddresses}
                                addresses={party.addresses}
                                relatedParties={party.relatedParties}
                                relatedIndividuals={party.relatedIndividuals}
                                relatedOrganisations={party.relatedOrganisations}
                                parentTitle={partyDescription}
                            />
                        </PartyCardWrapper>
                    );
                }
            }
        });

        return (
            
            <DataContainer className="data-container">
                <PartyInfoPanel infoItems={infoPanelItems} />
            </DataContainer>
        );
    }
}